<template>
<div>
  <header-component></header-component>
  <div class="px-2 py-2 w-full">
    <div class="card">
      <div class="card-header">
        <h3 class="mb-0" style="text-transform:capitalize;">Taxes List</h3>
        <div class="col-lg-12 col-5 text-right">
          <base-button size="sm" type="primary" @click="createTax">Add New</base-button>
        </div>
      </div>
      <el-table
        :data="taxList"
        class="table-responsive table-flush"
        header-row-class-name="thead-light"
      >
        <el-table-column label="Name" min-width="170px" prop="label" sortable />
        <el-table-column label="Rate" min-width="170px" prop="rate" sortable />
        <el-table-column label="Code" min-width="170px" prop="code" sortable />

        <el-table-column min-width="100px">
          <template slot-scope="scope">
            <el-dropdown slot="dropdown" @command="command => handleAction(scope.row, command)">
               <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
              <el-dropdown-menu slot="dropdown" class="dropdown-menu dropdown-menu-arrow show">
                <el-dropdown-item command="edit">Edit</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="Add Tax" :visible.sync="addTax">
    <add-tax @close="addTax = false"></add-tax >
      
    </el-dialog>
  </div>
  </div>
</template>
<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import AddTax from "./AddTax";
import { mapGetters, mapActions,mapMutations } from "vuex";
import headerComponent from "../Components/HeaderComponent";

export default {
  data: () => {
    return {
      addTax: false
    };
  },

  computed: {
    ...mapGetters({
      taxList: "tax/getTaxList",
      tax: "tax/getTax"
    })
  },

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    "add-tax": AddTax,
    [Dialog.name]: Dialog,
    [Button.name] : Button,
    "header-component": headerComponent

  },
  mounted() {
    this.getTaxes();
  },

  methods: {
    ...mapActions({ getTaxes: "tax/getTaxes", fetchTax: "tax/fetchTax" }),
    ...mapMutations({ setTax : "tax/setTax", resetTax :"tax/resetTax"}),
    handleAction(tax, command) {
      if (command === "edit") {
        this.fetchTax(tax.taxId).then((res) => {
          this.addTax = true;
          this.setTax(res);

        })
       // this.$router.push("/taxes/add/" + tax.Id);
      }
    },
    createTax() {
      this.addTax = true;
      this.resetTax();
    }
  }
};
</script>